import React from 'react'
import PropTypes from 'prop-types'
import Link from '@material-ui/core/Link'
import Typography from '@material-ui/core/Typography'

function OfferingCoachName({
  offering,
  classes,
  coachInfoPanelEnabled,
  onCoachProfileOpen,
}) {
  const name = offering.coach?.name || 'PGA Coach'

  if (coachInfoPanelEnabled && onCoachProfileOpen && offering.profileUrl) {
    return (
      <button
        type="button"
        className={`${classes.coachName} ${classes.coachNameLink} ${classes.coachNameButton}`}
        onClick={(event) => {
          event.stopPropagation()
          event.preventDefault()
          onCoachProfileOpen(offering)
        }}
      >
        {name}
      </button>
    )
  }

  if (offering.profileUrl) {
    return (
      <Link
        href={offering.profileUrl}
        target="_blank"
        rel="noopener noreferrer"
        variant="body2"
        className={`${classes.coachName} ${classes.coachNameLink}`}
        onClick={(event) => event.stopPropagation()}
      >
        {name}
      </Link>
    )
  }

  return (
    <Typography variant="body2" className={classes.coachName}>
      {name}
    </Typography>
  )
}

OfferingCoachName.propTypes = {
  offering: PropTypes.shape({
    profileUrl: PropTypes.string,
    coach: PropTypes.shape({
      name: PropTypes.string,
    }),
  }).isRequired,
  classes: PropTypes.shape({
    coachName: PropTypes.string,
    coachNameLink: PropTypes.string,
    coachNameButton: PropTypes.string,
  }).isRequired,
  coachInfoPanelEnabled: PropTypes.bool,
  onCoachProfileOpen: PropTypes.func,
}

OfferingCoachName.defaultProps = {
  coachInfoPanelEnabled: false,
  onCoachProfileOpen: undefined,
}

export default OfferingCoachName
